import Image from "next/image";

const LegitScriptBadge = () => {
    return (
        <a
            href="https://www.legitscript.com/websites/?checker_keywords=innerbalance.com"
            target="_blank"
            title="Verify LegitScript Approval"
            rel="noopener noreferrer"
            className="relative inline-block w-[70px] h-[70px] shrink-0"
        >
            <Image
                src="https://static.legitscript.com/seals/18796927.png"
                alt="LegitScript Approved certification badge — Inner Balance verified online pharmacy"
                fill
                sizes="70px"
                loading="lazy"
                className="object-contain"
            />
        </a>
    )
}

export default LegitScriptBadge;
